import React from 'react';
import styles from './PremiumButton.module.css';

/**
 * Premium CTA — tek kaynaktan hover-lift + mor glow, disabled ve loading durumları.
 * variant: primary (gradient) | secondary (outline) | ghost
 * size: sm | md | lg
 */
const PremiumButton = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  iconLeft,
  iconRight,
  type = 'button',
  className = '',
  children,
  ...rest
}) => {
  const classes = [
    styles.btn,
    styles[variant] || styles.primary,
    styles[size] || styles.md,
    fullWidth ? styles.fullWidth : '',
    loading ? styles.loading : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {!loading && iconLeft && <span className={styles.icon}>{iconLeft}</span>}
      {children && <span className={styles.label}>{children}</span>}
      {!loading && iconRight && <span className={styles.icon}>{iconRight}</span>}
    </button>
  );
};

export default PremiumButton;
